<template>
 <div></div>
</template>

<script setup>
import {computed, watch} from 'vue'
import {useSectionsStore} from "@/stores/section";
import {storeToRefs} from "pinia";
const sectionsStore = useSectionsStore()
const { fetchGemiusInfo } = sectionsStore
const { itemsGemiusDetails } = storeToRefs(sectionsStore)

import {useRouter} from "vue-router";
const router = useRouter()

const props = defineProps({
 objectId: {
   type: Number,
   default: 0
  }
})

const gemiusInfo = computed(() => itemsGemiusDetails.value?.[props.objectId])
const addGemiusCode = (gemiusInfo) => {
 let start = 1;
  window.gemiusView.setIdentifier(start, gemiusInfo.value.gemius_traffic, gemiusInfo.value.gemius_megapanel)
}

const gemiusPath = router.currentRoute.value.path;
if(gemiusPath !== '/szukaj') {
 watch (
  () => props.objectId,
  async () => {
   await fetchGemiusInfo(props.objectId).finally(()=>{
    addGemiusCode(gemiusInfo);
   })
  },
  { immediate: true }
 )
}

</script>
